// extracted by mini-css-extract-plugin
export default {"root":"QuizNavigation_root-_sf","backButton":"QuizNavigation_backButton-JXp","currentSlideText":"QuizNavigation_currentSlideText-wHv"};